<template>
  <div v-if="profile" class="lg:w-80">
    <div
      @click="withdrawValidations"
      class="
        flex
        items-center
        justify-between
        text-grey-2 text-sm
        font-semibold
        px-6
        lg:text-opacity-80 lg:font-normal
        hover:bg-yellow-6 hover:text-grey-1
      "
      :class="
        !hasMoney || !isRegular || isBorrower
          ? 'cursor-not-allowed opacity-50'
          : 'cursor-pointer'
      "
    >
      <div>
        <div class="flex my-6 lg:my-3">
          <img
            class="mr-4"
            src="@/assets/svg/home/withdraw.svg"
            alt="withdraw"
          />
          <p>
            {{ $t('home.drawer.withdraw') }}
          </p>
        </div>
      </div>

      <img
        src="@/assets/svg/arrows/right_grey_arrow.svg"
        alt="right"
        class="cursor-pointer lg:hidden"
      />
    </div>
    <div class="lg:hidden h-px w-full bg-grey-2 bg-opacity-10" />
    <!-- Autoinvestment -->
    <div v-if="!wallet.saving_id"
      @click="handleClick({ name: 'auto-investment' })"
      class="
        flex
        items-center
        justify-between
        text-grey-2 text-sm
        font-semibold
        px-6
        lg:text-opacity-80 lg:font-normal
        hover:bg-yellow-6 hover:text-grey-1
      "
      :class="
        (!isRegular || isBorrower)
          ? 'cursor-not-allowed opacity-50'
          : 'cursor-pointer'
      "    >
      <div class="flex my-6 lg:my-3">
        <img
          class="mr-4"
          src="@/assets/svg/home/autoinvestment.svg"
          alt="autoinvestment"
        />
        <p>
          <span
            v-if="!autoinvestmentsCount"
            >{{ $t('home.drawer.autoinvestment_create') }}</span
          >
          <span v-else>{{
            $t('home.drawer.autoinvestment_edit')
          }}</span>
        </p>
      </div>
      <img
        src="@/assets/svg/arrows/right_grey_arrow.svg"
        alt="right"
        class="lg:hidden"
      />
    </div>
    <div class="lg:hidden h-px w-full bg-grey-2 bg-opacity-10" />
    <!-- Strategy -->
    <!--<div v-if="!isStrategy"
      @click="handleClick()"
      class="
        flex
        items-center
        justify-between
        text-grey-2 text-sm
        font-semibold
        px-6
        pb-3
        rounded-b-2xl
        lg:text-opacity-80 lg:font-normal
        hover:bg-yellow-6 hover:text-grey-1
      "
      :class="
        !isRegular || strategiesCount > 0
          ? 'cursor-not-allowed opacity-50'
          : 'cursor-pointer'
      "
    >
      <div class="flex my-6 lg:my-3">
        <img class="mr-4" src="@/assets/svg/home/strategy.svg" alt="strategy" />
        <p>
          {{ $t('home.drawer.strategy_create') }}
        </p>
      </div>
      <img
        src="@/assets/svg/arrows/right_grey_arrow.svg"
        alt="right"
        class="lg:hidden"
      />
    </div>
    <div
      v-else
      @click="handleClick()"
      class="
        flex
        items-center
        justify-between
        text-grey-2 text-sm
        font-semibold
        px-6
        pb-3
        rounded-b-2xl
        lg:text-opacity-80 lg:font-normal
        hover:bg-yellow-6 hover:text-grey-1
      "
      :class="
        !isRegular || strategiesCount <= 0 || !activeStrategy
          ? 'cursor-not-allowed opacity-50'
          : 'cursor-pointer'
      "
    >
      <div class="flex my-6 lg:my-3">
        <img class="mr-4" src="@/assets/svg/home/strategy.svg" alt="strategy" />
        <p>
          {{ $t('home.drawer.strategy_edit') }}
        </p>
      </div>
      <img
        src="@/assets/svg/arrows/right_grey_arrow.svg"
        alt="right"
        class="lg:hidden"
      />
    </div>-->
  </div>
</template>

<script>
import { computed } from 'vue'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

export default {
  props: {
    hasMoney: {
      type: Boolean,
      default: false
    },
    isStrategy: {
      type: Boolean,
      default: false
    },
    isRegular: {
      type: Boolean,
      default: false
    },
    strategyId: {
      type: Number,
      default: -1
    },
    strategyName: {
      type: String,
      default: ''
    },
    wallet: {
      type: Object,
      default: () => {}
    },
    strategiesCount: {
      type: Number,
      default: 0
    },
    autoinvestmentsCount: {
      type: Number,
      default: 0
    },
    activeStrategy: {
      type: Number,
      default: 0
    },
  },
  emits: ['closeDrawer'],
  setup(props, { emit }) {
    const router = useRouter()
    const { slugIt } = useGlobalHelpers()
    const slug =
      props.strategyName && props.strategyName !== ''
        ? slugIt(props.strategyName) + '-' + props.strategyId
        : props.strategyId
    const store = useStore()
    const i18n = useI18n({ useScope: 'global' })
    const profile = computed(() => {
      return store.getters.getProfile()
    })
    const isBorrower = computed(() => {
      if (profile.value && profile.value.sub_type === 'borrower')
        return true
      return false
    })

    function goToWithdraw(wallet) {
      router.push({
        name: 'withdraw',
        params: {
          wallet: JSON.stringify(wallet)
        }
      })
    }

    const strategyRoute = computed(() => {
      if (props.isRegular) {
        if (props.strategiesCount > 0 && props.activeStrategy) {
          return '/strategies/edit/' + slug;
        }
        else if (props.strategiesCount <= 0) {
          return '/strategies-investment/start';
        }
      }
      return '';
    });

    const handleClick = (route) => {
      emit('closeDrawer')

      if (!props.isRegular) return

      const finalRoute = route || strategyRoute.value
      if (finalRoute) {
        router.push(finalRoute)
      }
    };

    const withdrawValidations = () => {
      if (!props.hasMoney || !props.isRegular) return
      else goToWithdraw(props.wallet)
    }

    return {
      slug,
      profile,
      isBorrower,
      goToWithdraw,
      withdrawValidations,
      handleClick
    }
  }
}
</script>

<style lang="scss" scoped></style>
